import { render, staticRenderFns } from "./NewGroupModal.vue?vue&type=template&id=1db838c4&"
import script from "./NewGroupModal.vue?vue&type=script&lang=js&"
export * from "./NewGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports